import { render, staticRenderFns } from "./BaseContainerBoxesTreeView.vue?vue&type=template&id=697b5a5c&scoped=true"
import script from "./BaseContainerBoxesTreeView.vue?vue&type=script&lang=js"
export * from "./BaseContainerBoxesTreeView.vue?vue&type=script&lang=js"
import style0 from "./BaseContainerBoxesTreeView.vue?vue&type=style&index=0&id=697b5a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697b5a5c",
  null
  
)

export default component.exports